import { z } from 'zod';

export const CalculatorFormSchema = z.object({
  Amount: z
    .string({ required_error: 'Bu alan boş bırakılamaz.' })
    .min(1, { message: 'Bu alan boş bırakılamaz.' })
    .refine(
      (value) => {
        const numericValue = value.replace(/\./g, '').replace(',', '.');
        return !isNaN(Number(numericValue));
      },
      { message: 'Geçerli bir kredi tutarı giriniz.' }
    )
    .transform((value) => Number(value.replace(/\./g, '').replace(',', '.')))
    .refine((num) => Number.isInteger(num), { message: 'Kredi tutarı küsuratsız olmalıdır.' })
    .refine((num) => num >= 1000, { message: "1.000 TL'den az olamaz." })
    .refine((num) => num <= 9999999, { message: "Kredi tutarı 9.999.999 TL'den fazla olamaz." }),
  Maturity: z.coerce.number({
    required_error: 'Bu alan boş bırakılamaz.',
    invalid_type_error: 'Bu alan boş bırakılamaz.',
  }),
});
